import { css } from "@emotion/react";

export const useStyles = (props) => ({
    whiteContentBarButton: css({
        height: "40px",
        padding: "10px 13px",
        borderRadius: "4px",
        marginBottom: "8px",
        width: "100%",
    }),
    leftContent: css({
        fontSize: "11px",
        color: "black",
        marginTop: 0,
        textAlign: "left",
        textTransform: "capitalize",
    }),
    rightContent: css({
        fontSize: "11px",
        color: "#00a7dd",
        marginTop: 0,
        textAlign: "right",
        textTransform: "none",
    }),
});
